"use client";

import { useQuery } from "@tanstack/react-query";
import { getPublicVoiceAgent } from "@/lib/api/generated/public-voice-agents/public-voice-agents";
import type { PublicVoiceAgentResponse } from "@/lib/api/model";
import QueryKey from "@/lib/query-key";

export const usePublicVoiceAgentQuery = (id: string) => {
  return useQuery({
    queryKey: [QueryKey.PUBLIC_VOICE_AGENT, id],
    queryFn: ({ signal }) => getPublicVoiceAgent(id, { signal }),
    select: (response: PublicVoiceAgentResponse) => response,
    enabled: !!id,
  });
};

// Public Voice Agentの型をre-export
export type { PublicVoiceAgentResponse };
